// Quantity × price with Indian grouping ("14,21,340.00"), shared by the table and
// the cards. Formatted, not printed raw, so float noise (6340.799999…) never
// shows. No currency symbol; null when quantity or price is missing.
export const formatTradeValue = (trade) => {
  const value = Number(trade.fill_quantity) * Number(trade.fill_price);
  return Number.isFinite(value)
    ? value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : null;
};
